import { getAPIPath, requestGooseAPI } from '../shared/request'
import {
  APILocationPetProfileClientDtoResponse,
  LocationPetProfileClientDto,
  LocationPetProfileCreateInput,
  LocationPetProfileUpdateInput,
} from '../types/api'
import { CLIENT_LOCATION_PETPROFILE_ID_PATH, CLIENT_LOCATION_PETPROFILE_PATH } from '../types/constants'

export interface TClientLocationPetProfileService {
  list: (locationName: string, lupId: string, includes?: string[]) => Promise<APILocationPetProfileClientDtoResponse>
  get: (locationName: string, lupId: string, lppId: string, includes?: string[]) => Promise<LocationPetProfileClientDto>
  put: (
    locationName: string,
    lupId: string,
    lppId: string,
    payload: LocationPetProfileUpdateInput,
    includes?: string[]
  ) => Promise<LocationPetProfileClientDto>
  post: (
    locationName: string,
    lupId: string,
    payload: LocationPetProfileCreateInput,
    includes?: string[]
  ) => Promise<LocationPetProfileClientDto>
}

export const ClientLocationPetProfileService: TClientLocationPetProfileService = {
  list: (locationName: string, lupId: string, includes?: string[]) =>
    requestGooseAPI<APILocationPetProfileClientDtoResponse>({
      url: getAPIPath(CLIENT_LOCATION_PETPROFILE_PATH, { locationId: locationName, lupId }),
      method: 'GET',
      params: {
        includes,
      },
    }),

  get: (locationName: string, lupId: string, lppId: string, includes?: string[]) => {
    return requestGooseAPI<LocationPetProfileClientDto>({
      url: getAPIPath(CLIENT_LOCATION_PETPROFILE_ID_PATH, { locationId: locationName, lupId, lppId }),
      method: 'GET',
      params: {
        includes,
      },
    })
  },

  put: (
    locationName: string,
    lupId: string,
    lppId: string,
    payload: LocationPetProfileUpdateInput,
    includes?: string[]
  ) =>
    requestGooseAPI<LocationPetProfileClientDto>({
      url: getAPIPath(CLIENT_LOCATION_PETPROFILE_ID_PATH, { locationId: locationName, lupId, lppId }),
      method: 'PUT',
      params: {
        includes,
      },
      data: payload,
    }),

  post: (locationName: string, lupId: string, payload: LocationPetProfileCreateInput, includes?: string[]) =>
    requestGooseAPI<LocationPetProfileClientDto>({
      url: getAPIPath(CLIENT_LOCATION_PETPROFILE_PATH, { locationId: locationName, lupId }),
      method: 'POST',
      params: {
        includes,
      },
      data: payload,
    }),
}
